import MetaTemplatesPage from './Index.vue';

export const routes = [
  {
    path: 'campanhas/templates-meta',
    name: 'meta_templates',
    meta: { permissions: ['administrator'] },
    component: MetaTemplatesPage,
  },
];
